import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex-grow overflow-y-auto p-2 text-gray-500"
}

import EntityListDetails from '@/components/Search/RightPane/EntityListDetails.vue';
import EntityListItem from '@/components/Search/RightPane/EntityListItem.vue';
import { SortBy, SortDirection } from '@/models/EntitySort';
import { SearchResponse } from '@/models/Search';
import store from '@/store';
import { computed, ref, Ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const allEntities = computed(() => store.getters['search/entities'] as SearchResponse[]);

const allEntitiesIdIdxMap: Ref<Map<number, number>> = computed(() => {
  const map = new Map<number, number>();
  for (let i = 0; i < allEntities.value.length; i++) {
    map.set(allEntities.value[i].entity.id, i);
  }
  return map;
});

const filteredEntityIds = computed(() => store.getters['search/filterEntityIds'] as Set<number>);
const sortBy = computed(() => store.getters['entitySort/sortBy'] as SortBy);
const sortDirection = computed(() => store.getters['entitySort/sortDirection'] as SortDirection);

const detailsEntityId: Ref<number | undefined> = ref(undefined);
const detailsEntity = computed(() => {
  if (detailsEntityId.value) {
    const i = allEntitiesIdIdxMap.value.get(detailsEntityId.value);
    if (i) {
      return allEntities.value[i];
    }
  }
  return undefined;
});

const closeDetails = () => {
  detailsEntityId.value = undefined;
};

const showOrHideDetails = (entityId: number) => {
  if (detailsEntityId.value === entityId) {
    detailsEntityId.value = undefined;
  } else {
    detailsEntityId.value = entityId;
  }
};

const filteredEntities = computed(() => {
  // filter
  const filteredEntities: SearchResponse[] = [];
  for (const id of filteredEntityIds.value) {
    const idx = allEntitiesIdIdxMap.value.get(id);
    if (idx) {
      filteredEntities.push(allEntities.value[idx]);
    }
  }

  // sort
  switch (sortBy.value) {
    case SortBy.RELEVANCE:
      if (sortDirection.value === SortDirection.DESC) {
        filteredEntities.sort((a, b) => b.score - a.score);
      } else {
        filteredEntities.sort((a, b) => a.score - b.score);
      }
      break;
    case SortBy.RECENCY:
      if (sortDirection.value === SortDirection.DESC) {
        filteredEntities.sort(
          (a, b) => new Date(b.entity.pubDate).getTime() - new Date(a.entity.pubDate).getTime()
        );
      } else {
        filteredEntities.sort(
          (a, b) => new Date(a.entity.pubDate).getTime() - new Date(b.entity.pubDate).getTime()
        );
      }
      break;
    case SortBy.CITATION_COUNT:
      if (sortDirection.value === SortDirection.DESC) {
        filteredEntities.sort((a, b) => b.entity.citationCount - a.entity.citationCount);
      } else {
        filteredEntities.sort((a, b) => a.entity.citationCount - b.entity.citationCount);
      }
      break;
    case SortBy.ALPHABETIC:
      if (sortDirection.value === SortDirection.DESC) {
        filteredEntities.sort((a, b) => {
          const titlea = a.entity.normalizedTitle;
          const titleb = b.entity.normalizedTitle;
          if (titlea > titleb) return 1;
          else if (titlea < titleb) return -1;
          else {
            return 0;
          }
        });
      } else {
        filteredEntities.sort((a, b) => {
          const titlea = a.entity.normalizedTitle;
          const titleb = b.entity.normalizedTitle;
          if (titlea < titleb) return 1;
          else if (titlea > titleb) return -1;
          else {
            return 0;
          }
        });
      }
      break;
  }

  return filteredEntities;
});

const entityList: Ref<HTMLElement | undefined> = ref(undefined);
const scrollPane: Ref<HTMLElement | undefined> = ref(undefined);
const selectedEntityId = computed(() => store.getters['search/selectedEntityId'] as number);

watch(selectedEntityId, () => {
  if (entityList.value && scrollPane.value) {
    for (const item of entityList.value.children) {
      const htmlItem = item as HTMLElement;
      const itemId = item?.id ? parseInt(item.id) : undefined;
      if (itemId === undefined) {
        console.error('item id undefined');
      }
      if (itemId === selectedEntityId.value && !isInViewport(htmlItem)) {
        scrollPane.value.scrollTo({
          top: htmlItem.offsetTop - item.clientHeight - 80,
          behavior: 'smooth',
        });
        break;
      }
    }
  }
});

// helper function (reference: https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/)
const isInViewport = (el: HTMLElement) => {
  try {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  } catch (e) {
    console.error(e);
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(filteredEntityIds) && _unref(filteredEntityIds).size > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: (_value, _refs) => {
          _refs['scrollPane'] = _value
          scrollPane.value = _value
        },
        class: "flex-grow overflow-y-auto p-2"
      }, [
        _createElementVNode("div", {
          id: "entityList",
          ref: (_value, _refs) => {
            _refs['entityList'] = _value
            entityList.value = _value
          }
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredEntities), (entity, idx) => {
            return (_openBlock(), _createBlock(EntityListItem, {
              key: idx,
              id: entity?.entity.id,
              entity: entity,
              onMoreInformation: showOrHideDetails
            }, null, 8, ["id", "entity"]))
          }), 128))
        ], 512),
        _createVNode(EntityListDetails, {
          entity: _unref(detailsEntity),
          onClose: closeDetails
        }, null, 8, ["entity"])
      ], 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, "No match"))
}
}

})